import request from '@/utils/request'
// 初始化-获取花名册字段分组信息(员工字段左侧菜单栏分组)
export const getWorkWechatGroup = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/init/get_work_wechat_group',
        data
    })
}
// 添加分组
export const wechatGroupAdd = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_group/add',
        data
    })
}
// 编辑分组
export const wechatGroupEdit = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_group/edit',
        data
    })
}
// 删除分组
export const wechatGroupDelete = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_group/delete',
        data
    })
}

// 删除
export const wechatFieldsDel = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/del',
        data
    })
}
// 添加字段
export const wechatFieldsAdd = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/add',
        data
    })
}
// 编辑字段
export const wechatFieldsEdit = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/edit',
        data
    })
}


// 动态字段列表(员工字段列表)
export const wechatFieldsList = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/list',
        data
    })
}

// 动态字段列表(动态字段 更新状态)
export const wechatFieldsUpdateStatus = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/update_status',
        data
    })
}
// 首页/花名册列表头部数据
export const rosterlistNum = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/roster/list_num',
        data
    })
}
// 首页/花名册列表头部数据
export const rosterGetFieldConfig = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/roster/get_field_config',
        data
    })
}
// 获取动态字段列表
export const wechatFieldsGetAddFields = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/get_add_fields',
        data
    })
}
// 花名册设置筛选/表头配置
export const rosterSetFieldConfig = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/roster/set_field_config',
        data
    })
}
// 花名册列表
export const merchantV2RosterList = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/roster/list',
        data
    })
}
// 花名册在职人员添加
export const merchantV2RosterAdd = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/roster/add',
        data
    })
}
// 花名册在职人员详情
export const merchantV2RosterDetail = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/roster/detail',
        data
    })
}
// 花名册在职人员编辑
export const merchantV2RosterEdit = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/roster/edit',
        data
    })
}
// 花名册导入
export const userImportImport = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/user_import/import',
        data
    })
}

// 花名册excel导入模版下载
export const userImportDownloadTemplate = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/user_import/download_template',
        data,
    })
}


// 扫码入职添加
export const addEntryAdd = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/add/entry_add',
        data,
    })
}


// 获取动态字段列表（扫码入职，不需要登陆的）
export const wechatFieldsGetNoAddFields = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/get_no_add_fields',
        data
    })
}

// 花名册在职人员详情（不需要登陆的）
export const merchantV2RosterEntryDetail = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/roster/entry_detail',
        data
    })
}

// 花名册完善资料编辑（不需要登陆的）
export const merchantV2RosterRosterEdit = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/roster/roster_edit',
        data
    })
}
// 入职管理 邀请完善资料
export const addEntryEdit = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/add/entry_edit',
        data,
    })
}

// 扫码入职用户详情 无鉴权  扫码完善资料用
export const addEntryDetail = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/add/entry_detail',
        data,
    })
}

// 确认入职详情
export const addEntrySureDetail = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/add/entry_sure_detail',
        data,
    })
}
// 确认入职
export const addAudit = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/add/add_audit',
        data,
    })
}

// 查询部门跟直属上级
export const getEntryUserInit = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/init/get_entry_user_init',
        data,
    })
}
// 身份证图片反查信息
export const wechatOcrIdcard= (data) => {
    return request({
        method: 'post',
        url: '/api/v1/wechat/ocr_idcard',
        data,
    })
}

// 拖拽排序
export const DraggableSort = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/update_order',
        data,
    })
}
// 银行卡图片反查银行卡账号信息
export const wechatOcrBankcard= (data) => {
    return request({
        method: 'post',
        url: '/api/v1/wechat/ocr_bankcard',
        data,
    })
}
// 银行卡账号信息反差开户银行
export const wechatBankInfo= (data) => {
    return request({
        method: 'post',
        url: '/api/v1/wechat/bank_info',
        data,
    })
}
// 获取过期时间
export const checkCodeTime= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/code/check_code_time',
        data,
    })
}
// 获取下拉选项的控件组
export const userOptionFieldInit= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/init/user_option_field_init',
        data,
    })
}
// 获取字段值
export const getFieldDefaultValue= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/get_field_default_value',
        data,
    })
}
// 设置关联选项

export const setRelationOption= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/set_relation_option',
        data,
    })
}
// 获取关联字段控件列表
export const getRelationOption= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/get_relation_option',
        data,
    })
}
// 获取工资、定级
export const countSalaryBefore= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_salary_config/fixed_field_change_value',
        data,
    })
}
// 薪资规则列表
export const wechatSalaryConfigList= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_salary_config/list',
        data,
    })
}

// 薪资规则详情
export const wechatSalaryConfigDetail= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_salary_config/detail',
        data,
    })
}
// 薪资规则添加
export const wechatSalaryConfigAdd= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_salary_config/add',
        data,
    })
}
// 薪资规则编辑
export const wechatSalaryConfigEdit= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_salary_config/edit',
        data,
    })
}
// 薪资规则删除
export const wechatSalaryConfigDel= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_salary_config/del',
        data,
    })
}
// 薪资规则列表统计
export const wechatSalaryConfigListNum= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_salary_config/list_num',
        data,
    })
}
export const getAllVisibleFields= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_fields/get_all_visible_fields',
        data,
    })
}
// 薪资规则列表字段
export const listFields= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/wechat_salary_config/list_fields',
        data,
    })
}
export const quitDownloadTemplateQuit= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/quit/download_template_quit',
        data,
    })
}
export const quitBatchImportQuit= (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/quit/batch_import_quit',
        data,
    })
}



